import { showElem, stopElemAnim, addCloseElemAnim, hideElem } from './utils';
import { timeout } from './utils';

const showSubmenu = (elem, overlay) => {
  stopElemAnim(elem);
  stopElemAnim(overlay);

  showElem(elem);
  showElem(overlay);
};

const hideSubmenu = (elem, overlay, target) => {
  addCloseElemAnim(overlay);
  addCloseElemAnim(elem);

  timeout.id = setTimeout(() => {
    hideElem(elem);

    if (
      !target ||
      (!target.classList.contains('nav-submenu-item__link') &&
        !target.classList.contains('header__bottom'))
    ) {
      hideElem(overlay);
    }
  }, 300);
};

export const initSubmenu = () => {
  const overlayTop = document.querySelector('.overlay-top');
  const overlayBottom = document.querySelector('.overlay-bottom');
  const submenuItems = document.querySelectorAll('.nav-submenu-item');

  submenuItems.forEach((submenuItem) => {
    const submenu = submenuItem.querySelector('.submenu');

    submenuItem.addEventListener('mouseenter', (e) => {
      clearTimeout(timeout.id);

      if (e.target.closest('.header__top')) {
        showSubmenu(submenu, overlayTop);
      }

      if (e.target.closest('.header__bottom')) {
        showSubmenu(submenu, overlayBottom);
      }
    });
    submenuItem.addEventListener('mouseleave', (e) => {
      if (e.target.closest('.header__top')) {
        hideElem(e.target.querySelector('.submenu'));
        hideSubmenu(submenu, overlayTop, e.relatedTarget);
      }

      if (e.target.closest('.header__bottom')) {
        hideElem(e.target.querySelector('.submenu'));
        hideSubmenu(submenu, overlayBottom, e.relatedTarget);
      }
    });
  });
};
